<template>
  <div class="vx-row " style="height: 55px">
    <div class="flex-1 mx-1" @click="activeCard('greenDiesel')">
      <vs-card actionable :class="{ active: isGreenDieselActive }">
        <h5 class="boldText text-center pt-1">
          <vs-icon size="20px" icon="location_on"></vs-icon>
          {{ $t("greenDiesel") }}
        </h5>
      </vs-card>
    </div>
    <div class="flex-1 mx-1" @click="activeCard('domesticOil')">
      <vs-card actionable :class="{ active: isDomesticOilActive }">
        <h5 class="boldText text-center pt-1">
          <vs-icon size="20px" icon="location_on"></vs-icon>
          {{ $t("domesticOil") }}
        </h5>
      </vs-card>
    </div>
    <div class="flex-1 mx-1" @click="activeCard('exportOil')">
      <vs-card actionable :class="{ active: isExportOilActive }">
        <h5 class="boldText text-center pt-1">
          <vs-icon size="20px" icon="location_on"></vs-icon>
          {{ $t("exportOil") }}
        </h5>
      </vs-card>
    </div>
  </div>
</template>

<script>
import { OIL_TYPE } from "@/constant/index";
import { mapState } from "vuex";
import _ from "lodash";
export default {
  data() {
    return {
      OIL_TYPE,
    };
  },
  computed: {
    ...mapState({
      isGreenDieselActive: (state) => state.isGreenDieselActive,
      isDomesticOilActive: (state) => state.isDomesticOilActive,
      isExportOilActive: (state) => state.isExportOilActive,
    }),
  },
  methods: {
    activeCard(typeOil) {
      switch (typeOil) {
        case OIL_TYPE.GREEN_DIESEL:
          this.$router.push("/");
          break;
        case OIL_TYPE.DOMESTIC_OIL:
          this.$router.push("/Domestic");
          break;
        case OIL_TYPE.EXPORT_OIL:
          this.$router.push("/Export");
          break;
        default:
      }
    },
  },
};
</script>

<style>
.active {
  background-color: #cccccc;
}
</style>
